import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DamageListDto,DamageStatusDto, MeasureDto, ItemTypeDto, UomDto  } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-damage-list',
  templateUrl: './damage-list.component.html',
  styleUrls: ['./damage-list.component.scss']
})
export class DamageListComponent implements OnChanges {

  @Input() damagelists: DamageListDto[];
  @Input() itemtypes: ItemTypeDto[];
  @Input() measures: MeasureDto[]
  @Input() uoms: UomDto[]
  @Input() damagestatuss: DamageStatusDto[]
  damagelistForm: FormGroup;
  damagelistFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<DamageListDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredDamageList: Array<any> = [];
  status: boolean;
  selectedDamageId: any;
  selectedIndex = null;
  MeasureName: string;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createDamageListForm();
  }

  createDamageListForm() {
    this.damagelistFormArray = this.fb.group({ DamageLists: this.fb.array([]) });
    this.damagelistForm = this.fb.group({
        ItemName: ['', Validators.required],
        ItemTypeId: this.selectedDamageId,
        MeasureId: [''],
        MeasureName: [''],
        OptApprovedRate: [0],
        CompanyApprovedRate: [0],
        UomId: ['', Validators.required],
        DamageStatusId: ['', Validators.required],
        id: null
    });
  }


  // method to display companies
  setDamageList() {
    const control = this.damagelistFormArray.controls.DamageLists as FormArray;
    this.filteredDamageList.forEach((e) => {
      control.push(
        this.fb.group({
          ItemName: e.ItemName,
          ItemTypeId: e.ItemTypeId,
          MeasureId: e.MeasureId,
          MeasureName: e.MeasureName,
          OptApprovedRate: e.OptApprovedRate,
          CompanyApprovedRate: e.CompanyApprovedRate,
          UomId: e.UomId,
          DamageStatusId: e.DamageStatusId,
          id: e.id,
        })
      );
    });
  }

  onSelectMeasureName(id: string) {
    this.MeasureName = this.measures.find(measure => measure.id === id).MeasureName || null;
  }

   // method to add Company
   addDamageList(damagelist: DamageListDto) {
    console.log('damagelist');
    const control = this.damagelistFormArray.controls.DamageLists as FormArray;
    control.insert(
      0,
      this.fb.group({
        ItemName: damagelist.ItemName,
        ItemTypeId: this.selectedDamageId,
        MeasureId: damagelist.MeasureId,
        UomId: damagelist.UomId,
        MeasureName: this.MeasureName,
        OptApprovedRate: damagelist.OptApprovedRate,
        CompanyApprovedRate: damagelist.CompanyApprovedRate,
        DamageStatusId: damagelist.DamageStatusId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.damagelistFormArray.controls.DamageLists as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter country
  selectItemType(event: string) {
    this.filteredDamageList = this.damagelists.filter((s) => s.ItemTypeId === event);
    this.selectedDamageId = event;
    const control = this.damagelistFormArray.controls.DamageLists as FormArray;

    if (this.filteredDamageList.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setDamageList();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteDamageList(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.damagelistFormArray.controls.DamageLists as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.damagelists.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.damagelists[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: DamageListDto) {
    if(this.damagelistForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.damagelistFormArray.get('DamageLists')['controls'][this.selectedIndex].patchValue({
        ...formValue,
        MeasureName: this.MeasureName != null ? this.MeasureName : formValue?.MeasureName
      });
    } else {
      this.addDamageList(formValue);
    }
    this.selectedIndex = null;
    this.damagelistForm.reset()
  }

  onEdit(index, value: DamageListDto) {
    this.selectedIndex = index;
    this.damagelistForm.patchValue(value);
  }

  onClearForm() {
    this.selectedIndex = null;
    this.damagelistForm.reset();
  }


  getMeasureName(id: string) {
    const found = this.measures.find(acc => acc.id === id);
    //console.log('log ', id)
    return found ? found.MeasureName : '';
  }
  getUomName(id: string) {
    const found = this.uoms.find(acc => acc.id === id);
    //console.log('log ', id)
    return found ? found.UomName : '';
  }
  getDamageStatusName(id: string) {
    const found = this.damagestatuss.find(acc => acc.id === id);
   // console.log('log ', id)
    return found ? found.DamageStatusName : '';
  }

  onSubmit(formValue: any) {
    formValue.type = 'damagelist';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('damagelist');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
